<template>
  <div class="declare-wrap">
     <el-container>
      <el-header >
          <!-- 头部 -->         
          <AppHeader/>
      </el-header>
      <el-container style="overflow:auto">
        <el-aside width="202px">
        <!-- 侧边栏 -->
        <AppAside/>
        </el-aside>
        <!-- 内容 -->
        <el-main>
          <keep-alive>
          <router-view :key="$route.path"/>
          </keep-alive>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import AppAside from './components/AppAside'
import AppHeader from './components/AppHeader'
import { getmenu } from '../../API'
import { parantId } from '../../util/parantId'
export default {
  name: 'Declare',
  components: {
    AppAside,
    AppHeader
  },
  data () {
    return {
    }
  },
  created () {
    // this.$store.commit('permissionList/COMMIT_DATA',JSON.parse(localStorage.getItem('permissionList')))
    getmenu().then(res => {
      if (res.code === 0) {
        // localStorage.setItem('permissionList',JSON.stringify(res.data))
        this.$store.commit('permissionList/COMMIT_DATA',res.data)
        parantId(this.$store.state.permissionList.data, this.$route.path, this.$store)
      }
    })
  },
}
</script>

<style lang='less' scoped>
.el-main{
  padding: 0;
}
.declare-wrap{
    width: 100%;
    height: 100%;
    position: relative;
}
.el-container {
  height: 100%;
}
.el-aside {
  background-color: #343a46;
  height: 100%;
}
.el-header {
    background:#3498DB;
}
.el-main {
  background-color: #e8eff4;
}
.AppTop{
margin-bottom: 30px;
}
</style>
